import React from 'react';
import { Form } from 'react-bootstrap';
export default function HospitalarStockUnitSelect({ options = [], ...props }) {
    return <><Form.Select {...props} required aria-label="Unidade de medida do estoque"><option value="">Selecione a unidade de medida</option>{options.map(unit => <option key={unit.codigo} value={unit.codigo}>{unit.nome}</option>)}</Form.Select><Form.Text>Como este produto será contado no estoque. Não corresponde à Matriz ou filial. Exemplo: comprimido, ampola ou mL.</Form.Text></>;
}
